import {inject, Injectable} from "@angular/core";
import {APP_CONFIG_TOKEN} from "../services/app-config/app-config";

@Injectable({providedIn: 'root'})
export class DefinedPaths {
  public appConfig = inject(APP_CONFIG_TOKEN);
  public UserCompanyEndpoint: string;
  public CompanyEndpoint: string;
  public ProviderBaseEndpoint: string;
  constructor() {
    this.UserCompanyEndpoint = `${this.appConfig.api.url}/api/v1/user-company`;
    this.ProviderBaseEndpoint = `${this.appConfig.api.url}/api/v1`;
    this.CompanyEndpoint = `${this.appConfig.api.url}/api/v1/user-company/UserCompany`;
  }
}
